import {
    resizeFuncCheck,
    resizeFunc,
    resizecheck
} from './_resizecheck';
var mainContent, headerHei, resultHead;
export function heightAdjustmentFunc() {}
var scrTop;
export function contentAdjustmentFunc() {
    mainContent = '#mainContent';
    headerHei = '#header';
    resultHead = $(headerHei).outerHeight(true);
    scrTop = $(document).scrollTop();

    resizeFuncCheck();
    resizeFunc();

    if (resizecheck != 1) {
        resultHead = $(headerHei).outerHeight(true);
        $(mainContent).css('padding-top', resultHead);
    } else {
        if (scrTop > 0) {
            $(mainContent).css('padding-top', 158);
        } else {
            $(mainContent).removeClass('adjust');
        }
    }
    
    //リサイズ時の処理
    $(window).on('resize', function () {
        resizeFuncCheck();
        resizeFunc();
        scrTop = $(document).scrollTop();
        if (resizecheck != 1) {
            setTimeout(function(){
            resultHead = $(headerHei).outerHeight(true);
            $(mainContent).css('padding-top', resultHead);
            },500);
        } else {
            if (scrTop > 0) {
                $(mainContent).addClass('adjust');
            } else if (scrTop == 0) {
                $(mainContent).removeClass('adjust');
                $(mainContent).removeAttr('style');
            }
        }
    });
    
    //Scroll時の処理
    $(window).on('scroll', function () {
        resizeFuncCheck();
        resizeFunc();
        scrTop = $(document).scrollTop();
        
        if (resizecheck == 1) {
            if (scrTop > 0) {
                $(mainContent).addClass('adjust');
            } else if (scrTop == 0) {
                $(mainContent).removeClass('adjust');
                $(mainContent).removeAttr('style');
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_common.js
// module id = 11
// module chunks = 0